import { NavLink, useNavigate } from 'react-router-dom'
import { StatusBadge } from './StatusBadge'
import type { OwnerEvent } from '../../api/ownerTypes'

/** De zes bestemmingen uit de zijnavigatie van ronde 20P, 20R, 20S, 20T en 20U. */
const destinations = [
  { to: '', label: 'Overzicht', icon: '▣', end: true },
  { to: 'info', label: 'Eventinfo', icon: '✎', end: false },
  { to: 'gasten', label: 'Gasten', icon: '☺', end: false },
  { to: 'exporteren', label: 'Exporteren', icon: '⤓', end: false },
  { to: 'qr', label: 'QR-code', icon: '◫', end: false },
  { to: 'challenges', label: 'Challenges', icon: '◎', end: false },
  { to: 'instellingen', label: 'Instellingen', icon: '⚙', end: false },
]

/**
 * De zijnavigatie van een event. Alleen op desktop: op mobiel zijn dit de
 * rijen in de "Beheren"-lijst op de eventpagina.
 */
export function EventRail({ subject }: { subject: OwnerEvent }) {
  const navigate = useNavigate()

  return (
    <aside className="border-line-soft hidden w-72 shrink-0 flex-col border-r px-5 py-7 lg:flex">
      <button
        type="button"
        onClick={() => navigate('/beheer')}
        className="text-ink-soft flex items-center gap-2.5 px-2 pb-5.5 text-sm"
      >
        <span aria-hidden="true" className="text-[15px]">
          ←
        </span>
        Mijn events
      </button>

      <div className="border-line-soft border-b px-2 pb-5.5">
        <p className="font-display text-[28px] leading-[1.1]">{subject.title}</p>

        {/* Of gasten erbij kunnen. Dat stond hier eerst als publicatiestatus, en
            die zei niets: "Live" bleef staan tot in de eeuwigheid. */}
        <div className="mt-2.5 -ml-1">
          <StatusBadge isPrivate={subject.isPrivate} />
        </div>
      </div>

      <nav className="flex flex-col gap-1 pt-4">
        {destinations.map((destination) => (
          <NavLink
            key={destination.label}
            to={destination.to}
            end={destination.end}
            className={({ isActive }) =>
              'flex h-11 items-center gap-3 rounded-[13px] px-3.5 text-[15px] ' +
              (isActive ? 'bg-tint text-accent font-semibold' : 'text-ink-muted hover:bg-tint/40')
            }
          >
            {({ isActive }) => (
              <>
                <span
                  aria-hidden="true"
                  className={'w-4.5 text-center ' + (isActive ? '' : 'text-ink-soft')}
                >
                  {destination.icon}
                </span>
                {destination.label}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="flex-1" />

      <div className="border-line-soft border-t pt-4">
        <a
          href={subject.guestUrl}
          target="_blank"
          rel="noreferrer"
          className="border-line text-ink-muted hover:bg-tint/50 hover:text-ink flex h-11.5 items-center justify-center gap-2.25 rounded-full border text-[15px] transition-colors"
        >
          Bekijk de galerij
        </a>
      </div>
    </aside>
  )
}
